export default {
      id: "add-usage",
      viewBox: "0 0 24 24",
      url: "assets/" + "sprite.svg#add-usage",
      toString: function () {
        return this.url;
      }
    }